import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { StyledIntegrationTag } from "../styles";

export const StyledSingleAccountTag = styled(StyledIntegrationTag)`
    background-color: ${colorsPalettes.torquoise["50"]};
    padding: 6px 16px;

    & span {
        color: ${colorsPalettes.torquoise["500"]};
    }

    &:hover {
        background-color: ${colorsPalettes.torquoise["100"]};
    }
`;
